import { Provider } from './components/chakra-ui/provider';
import Home from './components/home';
import { Box } from '@chakra-ui/react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import SocialMediaLinks from './components/social-media';
import ViewPhotos from './components/view-photos';
import QRCodePage from './components/qr-code-page';
import ScrollToTop from './components/core/scroll-to-top';
import UpdateHashOnScroll from './components/core/update-hash-on-scroll';
import './App.css';
import { NAV_OFFSET, CONFIG_BASE_URL } from './components/core/constants';
import { useEffect, useState } from 'react';
import useScrolledToBottom from './components/core/scrolled-bottom';
import axios from 'axios';
import CustomerEvent from './components/customer-event';
import AdminGuard from './components/admin/core/AdminGuard';
import AdminLayout from './components/admin/core/AdminLayout';
import AdminLanding from './components/admin/core/AdminLanding';
import EventManager from './components/admin/manage-events/event-manager';
import AdminAllEvents from './components/admin/manage-events/all-events';
import ManageVideos from './components/admin/manage-videos/manage-videos';
import ManageImages from './components/admin/manage-images/manage-images';

function App() {
  const [galleryItems, setGalleryItems] = useState([]);
  const [allImages, setAllImages] = useState([]);
  const [allVideos, setAllVideos] = useState([]);
  const [allEvents, setAllEvents] = useState([]);

  const [loading, setLoading] = useState(true);

  const isBottom = useScrolledToBottom(150); // 150px tolerance

  useEffect(() => {
    // https://raw.githubusercontent.com/vianphoto27/vian-photography-public/main/config/gallery-items-metadata.json
    // https://raw.githubusercontent.com/vianphoto27/vian-photography-public/main/config/images.json
    const baseUrl = CONFIG_BASE_URL;

    const files = ['images.json', 'videos.json', 'events.json'];

    const axiosConfig = {
      headers: { Accept: 'application/vnd.github.v3.raw' }
    };

    axios
      .all(files.map((file) => axios.get(`${baseUrl}/${file}`, axiosConfig)))
      .then(
        axios.spread((imagesRef, videos, events) => {
          const imagesV2Data = imagesRef.data || [];

          // Maintain legacy compatibility
          const allImagesObj = {};
          imagesV2Data.forEach((item) => {
            allImagesObj[item.urlPath] = item.images || [];
          });

          setGalleryItems(imagesV2Data);
          setAllImages(allImagesObj);
          setAllVideos(videos.data || []);
          setAllEvents(events.data || []);
        })
      )
      .catch((err) =>
        console.error('Failed to fetch one or more configs:', err)
      )
      .finally(() => setLoading(false));
  }, []);

  const [isHero, setIsHero] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Hide if in the top 400px (Hero area)
      setIsHero(window.scrollY < 400);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check once on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (loading) return <p>Loading images...</p>;

  return (
    <Provider>
      <ScrollToTop />
      <UpdateHashOnScroll />

      <Box p={0}>
        {/* Header */}
        <div className="header-section" style={{ height: NAV_OFFSET + 'px' }}>
          <Header />
        </div>

        {/* Routes */}
        <div className="content-section">
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  galleryItems={galleryItems}
                  allImages={allImages}
                  allVideos={allVideos}
                />
              }
            />
            <Route
              path="/view-photos/:urlPath"
              element={
                <ViewPhotos
                  allImages={allImages}
                  galleryItems={galleryItems}
                  allVideos={allVideos}
                />
              }
            />
            <Route
              path="/events/:eventId"
              element={<CustomerEvent allEvents={allEvents} />}
            />
            <Route
              path="/qr-codes"
              element={<QRCodePage />}
            />
            {/* public events list removed; use /admin/events for managed access */}
            <Route path="/admin" element={<AdminGuard />}>
              <Route element={<AdminLayout />}>
                <Route index element={<AdminLanding />} />
                <Route
                  path="manage-events"
                  element={<AdminAllEvents allEvents={allEvents} />}
                />
                <Route path="manage-videos" element={<ManageVideos />} />
                <Route path="manage-images" element={<ManageImages />} />
                <Route path="manager" element={<EventManager />} />
              </Route>
            </Route>
            <Route path="*" element={<h2>Page Not Found</h2>} />
          </Routes>
        </div>

        {/* Footer */}
        <Box className="footer-section">
          <Footer />

          {!isBottom && !isHero && (
            <Box
              position="fixed"
              bottom="30%" // Adjusted to be less intrusive than 50%
              right="0.5rem"
              zIndex={2000}
            >
              <SocialMediaLinks flexDirection="column" noBackground={false} />
            </Box>
          )}
        </Box>
      </Box>
    </Provider>
  );
}

export default App;
